module.exports = __webpack_public_path__ + "img/footer4.00f96279.jpg";